'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _keys2 = require('lodash/keys');
var _keys3 = _interopRequireDefault(_keys2);
var _isEmpty2 = require('lodash/isEmpty');
var _isEmpty3 = _interopRequireDefault(_isEmpty2);
var _reduce2 = require('lodash/reduce');
var _reduce3 = _interopRequireDefault(_reduce2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
var _omit2 = require('lodash/omit');
var _omit3 = _interopRequireDefault(_omit2);
var _each2 = require('lodash/each');
var _each3 = _interopRequireDefault(_each2);
var _map2 = require('lodash/map');
var _map3 = _interopRequireDefault(_map2);
exports.default = focus;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function focus(series, focusSelections) {
  // scatter has only 1 serie
  var serie = (0, _get3.default)(series, '[0]', {});
  var _focusSelections = (0, _reduce3.default)(focusSelections, function (memo, focusSelection, focusKey) {
    if (!(0, _isEmpty3.default)(focusSelection)) memo[focusKey] = focusSelection;
    return memo;
  }, {});
  if ((0, _isEmpty3.default)(_focusSelections)) return series;
  var datapoints = (0, _get3.default)(serie, 'datapoints', []);
  var _datapoints = (0, _map3.default)(datapoints, function (datapoint) {
    return (0, _omit3.default)(datapoint, (0, _map3.default)((0, _keys3.default)(focusSelections), function (focusKey) {
      return focusKey + 'Index';
    }));
  });
  var __datapoints = (0, _map3.default)(_datapoints, function (datapoint) {
    (0, _each3.default)(_focusSelections, function (focusSelection, focusKey) {
      var _focusKey = focusKey + 'Index';
      (0, _each3.default)(focusSelection, function (focus, i) {
        var _focus = (0, _get3.default)(focus, 'options', {});
        var dimensionValueId = (0, _get3.default)(datapoint, 'dimensionValues.' + _focus.dimensionId + '.id');
        if (dimensionValueId === _focus.dimensionValueId) datapoint[_focusKey] = i;
      });
    });
    return datapoint;
  });
  return [(0, _extends3.default)({}, serie, {
    datapoints: __datapoints
  })];
}